export default "__VITE_ASSET__3cb52c65__"